import type { EmployeeSummary } from '@blesk/contracts';
import { ROLE_LABEL } from '../../shared/labels';

/**
 * Дополнение №1, А13. Выбор наблюдателей задач Bitrix24 — общий для объекта
 * (менеджер КО) и для настройки «во всех задачах» (руководитель ОП и заместитель).
 *
 * Сотрудник без пользователя портала назначается, но в задачу не попадёт:
 * это говорится рядом с именем, а не обнаруживается по пустому списку
 * наблюдателей в Bitrix24.
 */
export function ObserverPicker({
  employees,
  value,
  onChange,
  disabled,
}: {
  employees: EmployeeSummary[];
  value: string[];
  onChange: (ids: string[]) => void;
  disabled?: boolean;
}) {
  // Уже назначенный, но заблокированный сотрудник в списке активных отсутствует —
  // без своей строки его нельзя было бы снять
  const missing = value.filter((id) => !employees.some((employee) => employee.id === id));

  const toggle = (id: string, checked: boolean) =>
    onChange(checked ? [...value, id] : value.filter((item) => item !== id));

  if (employees.length === 0 && missing.length === 0) {
    return <p className="muted">Действующих сотрудников нет.</p>;
  }

  return (
    <div className="observer-picker" role="group" aria-label="Наблюдатели">
      {employees.map((employee) => (
        <label key={employee.id} className="check">
          <input
            type="checkbox"
            checked={value.includes(employee.id)}
            disabled={disabled}
            onChange={(event) => toggle(employee.id, event.target.checked)}
          />
          <span>{employee.fullName}</span>
          <span className="muted">
            {ROLE_LABEL[employee.role]}
            {employee.bitrixUserId === null
              ? ' · нет пользователя Bitrix24 — в задачи не попадёт'
              : ''}
          </span>
        </label>
      ))}
      {missing.map((id) => (
        <label key={id} className="check">
          <input type="checkbox" checked disabled={disabled} onChange={() => toggle(id, false)} />
          <span>Заблокированный сотрудник</span>
          <span className="muted">в задачи не попадёт — снимите отметку</span>
        </label>
      ))}
    </div>
  );
}
